module.exports = __webpack_public_path__ + "images/icons/flags/ZA-e49da4da.svg";